/* unplugin-vue-components disabled */import script from "./CinemaFolderShortcut.vue?vue&type=script&setup=true&lang=ts"
export * from "./CinemaFolderShortcut.vue?vue&type=script&setup=true&lang=ts"

import "./CinemaFolderShortcut.vue?vue&type=style&index=0&id=3ea61362&lang=scss&scoped=true"

import exportComponent from "/var/static/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea61362"]])

export default __exports__